// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"_93444fe79c--fullscreen--h_lwE"};